const BatchStatusEnum = {
  DEACTIVATED: 1,
  ACTIVATED: 2
}

export default BatchStatusEnum


// WEBPACK FOOTER //
// ./src/enum/batchStatusEnum.js